import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiamond = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 15,
	viewBox: "0 0 12 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.99316 14.7217C5.51465 14.7217 5.26855 14.4004 4.8584 13.8467L0.832031 8.47363C0.592773 8.15918 0.490234 7.86523 0.490234 7.56445C0.490234 7.25684 0.592773 6.96973 0.832031 6.65527L4.8584 1.28223C5.26855 0.728516 5.51465 0.407227 5.99316 0.407227C6.47168 0.407227 6.71777 0.728516 7.13477 1.28223L11.1611 6.65527C11.3936 6.96973 11.5029 7.25684 11.5029 7.56445C11.5029 7.86523 11.3936 8.15918 11.1611 8.47363L7.13477 13.8467C6.71777 14.4004 6.47168 14.7217 5.99316 14.7217Z",
		fill: "#BF5AF2"
	})
});
export default SvgDiamond;
